import React, { useMemo, FC } from 'react'
import { ThemeProvider, Theme, StyledEngineProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline'

import {
  APP_PALETTE,
} from './settings'

const ThemeFactory: FC<React.PropsWithChildren<unknown>> = (props) => {

  const theme = useMemo(() => {
    return createTheme({
      palette: APP_PALETTE,
    });
  }, [])
  
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        { props.children }
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default ThemeFactory